import { render, staticRenderFns } from "./aiCustomPagePagePartConfig.vue?vue&type=template&id=3de6c63d&scoped=true&"
import script from "./aiCustomPagePagePartConfig.vue?vue&type=script&lang=js&"
export * from "./aiCustomPagePagePartConfig.vue?vue&type=script&lang=js&"
import style0 from "./aiCustomPagePagePartConfig.vue?vue&type=style&index=0&id=3de6c63d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de6c63d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3de6c63d')) {
      api.createRecord('3de6c63d', component.options)
    } else {
      api.reload('3de6c63d', component.options)
    }
    module.hot.accept("./aiCustomPagePagePartConfig.vue?vue&type=template&id=3de6c63d&scoped=true&", function () {
      api.rerender('3de6c63d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/aiCustomPage/aiCustomPagePagePartConfig.vue"
export default component.exports